import type { MessageDescriptor } from 'react-intl';

import { LANG_ENV } from 'config/env';
import { routes } from 'config/routes';

import type { Locale } from '../../../../constants';

interface Link {
    id: MessageDescriptor['id'];
    href: string;
}

const links = {
    home: {
        id: 'mainNavigation.navigation.home',
        href: routes['/'],
    },
    appDevelopment: {
        id: 'mainNavigation.navigation.apps',
        href: routes['/app-development'],
    },
    design: {
        id: 'mainNavigation.moreLinks.design',
        href: routes['/designPage'],
    },
    references: {
        id: 'mainNavigation.navigation.references',
        href: routes['/references'],
    },
    about: {
        id: 'mainNavigation.navigation.about',
        href: routes['/about-us'],
    },
    contact: {
        id: 'mainNavigation.navigation.contact',
        href: routes['/contact'],
    },
    career: {
        id: 'mainNavigation.moreLinks.career',
        href: routes['/career'],
    },
    blog: {
        id: 'mainNavigation.moreLinks.blog',
        href: routes['/blog'],
    },
    prague: {
        id: 'mainNavigation.moreLinks.prague',
        href: routes['/contact/prague'],
    },
    berlin: {
        id: 'mainNavigation.moreLinks.berlin',
        href: routes['/contact/berlin'],
    },
} as const satisfies { [name: string]: Link };

type LocalizedLinks = {
    [key in Locale]: {
        mainNavigation: Link[];
        moreLinks: Link[];
    };
};

const localizedLinks: LocalizedLinks = {
    cs: {
        mainNavigation: [links.home, links.appDevelopment, links.design, links.references, links.about, links.contact],
        moreLinks: [links.career, links.blog, links.prague, links.berlin],
    },
    en: {
        mainNavigation: [links.home, links.appDevelopment, links.design, links.references, links.about, links.contact],
        moreLinks: [links.career, links.blog, links.prague, links.berlin],
    },
    de: {
        mainNavigation: [links.home, links.appDevelopment, links.design, links.references, links.about, links.contact],
        moreLinks: [links.blog, links.prague, links.berlin],
    },
};

export const content = localizedLinks[LANG_ENV];
